import { isLoggedIn } from "../component/Auth/Auth";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  return isLoggedIn() ? children : children;
};

export default ProtectedRoute;
